<template>
  <div class="row align-items-center pt-2 pb-2 border-top" >
<div class="col-sm-6">
        <span class>{{ labelText }}</span>
      </div>
      <div class="col-sm-6">
       <textarea
          cols="30"
          rows="5"
         :name="fieldName"
      :value="value"
      @input="$emit('input',$event.target.value)"
      :placeholder="labelText"
          class="w-50 form-control"
        ></textarea>
   
      </div>
      </div>
  <!-- <div class="col-3">
    <label>{{labelText}}</label>

    <k-input
      class="w-100"
      type="text"
      :name="fieldName"
      :value="value"
      @input="$emit('input',$event.target.value)"
      :placeholder="labelText
           "
    ></k-input>
  </div> -->
</template>
<script>
export default {
  name: "Textarea",
  props: ["placeholder", "labelText", "fieldName", "value"]
};
</script>